<template>
	<Teleport to="body">
		<Transition>
			<div class="popup is-active" :class="class" v-if="isActive" @click.self="$emit('close')" >
				<div class="popup__content">
					<button class="popup__close" type="button" @click="handleXButton"></button>
					<div class="popup__head">
						<div class="popup__icon">
                            <img :src="`${theme_path.url}/resources/images/svg/icon-support.svg`" alt="">
                        </div>
                    
                        <h3 class="popup__title">
                            {{ __('There is an issue!') }}
                        </h3>
					</div><!-- /.popup__head -->
	
					<div class="popup__inner">
						<div class="popup__body">
                            {{ __('Please contact the bank branch or enter valid credit card details.') }}
						</div><!-- /.popup__body -->
					</div><!-- /.popup__inner -->
				</div><!-- /.popup__content -->
			</div><!-- /.popup -->
		</Transition>
	</Teleport>
</template>

<script setup>
import { onMounted, onUnmounted, useSlots, watch, ref } from 'vue'
import { __ } from '@/utils';
const slots = useSlots()
const emit = defineEmits(['close', 'popup_x'])

const props = defineProps({
	class: String,
	isActive: Boolean,
})

const handleKeyPress = (event) => {
	if (event.keyCode === 27 && props.isActive) {
		emit('close')
	}
}

const handleXButton = () => {
	emit('close')
	emit('popup_x')
}

onMounted(() => document.addEventListener('keydown', handleKeyPress))
onUnmounted(() => document.removeEventListener('keydown', handleKeyPress))

</script>

<style scoped>
	.v-enter-active,
	.v-leave-active {
		transition: all 0.3s ease;
	}

	.v-enter-from,
	.v-leave-to {
		visibility: hidden;
		opacity: 0;
	}
</style>
